import { BaseController } from '@maia/feature-utils';
import { TaskDto, TaskService } from '@maia/shared';

export class TaskController extends BaseController {
  constructor(private taskService: TaskService) {
    super();
  }

  async getTasks(search: Record<string, unknown>) {
    return await this.getEntities(
      this.taskService,
      { path: 'tasks', search },
      TaskDto,
    );
  }

  async getTask(guid: string) {
    return await this.getEntity(this.taskService, `tasks/${guid}`, TaskDto);
  }

  async sendMessage(
    params: Parameters<typeof this.taskService.sendMessage>[number],
  ) {
    return await this.taskService.sendMessage(params);
  }

  async updateOptions(
    params: Parameters<typeof this.taskService.updateOptions>[number],
  ) {
    return await this.taskService.updateOptions(params);
  }

  async create(params: Parameters<typeof this.taskService.create>[number]) {
    return await this.taskService.create(params);
  }
}
